import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Firebase (handleCodeInApp) ouvre parfois /?mode=resetPassword&oobCode=… sans hash.
 * On redirige vers la route HashRouter correspondante.
 */
export default function AuthActionRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('mode') !== 'resetPassword' || !params.get('oobCode')) return;
    if (window.location.hash.startsWith('#/complete-password-reset')) return;
    navigate(`/complete-password-reset?${params.toString()}`, { replace: true });
  }, [navigate]);

  return null;
}
